const ENGLISH = {
  belgium: 'Belgium',
  germany: 'Germany',
  luxembourg: 'Luxembourg',
  netherlands: 'Netherlands',
  denmark: 'Denmark',
  Animate_years: 'Play years',
  Close : 'Close',
  Country : 'Country',
  Female: 'Female',
  Male: 'Male',
  No: 'No',
  Pups: 'Pups',
  Region: 'Region',
  Reproduction: 'Reproduction',
  Restart: 'Reset map',
  Status: 'Status',
  Stop_animation: 'Stop animation',
  Territory: 'Territory',
  Year: 'Year',
  Yes: 'Yes',
  about_this_map: 'About this map',
  all_territories_from: 'All Territories from',
  couple: 'pair',
  couples: 'pairs',
  data_benelux_germany : 'Data Benelux, Danmark and Germany until May 2025',
  individual: 'individual',
  individuals: 'individuals',
  more_info: 'More info',
  pack: 'pack',
  packs: 'packs',
  press_enter_to_select: 'Press enter to select',
  pups: 'pups',
  reproduction_took_place_in : 'Reproduction took place in',
  select_region: 'Select a region',
  select_territory: 'Select a territory',
  select_country: 'Select a country',
  selected: 'Selected',
  territorial_wolves_regions: 'Territorial wolves lived in the following regions',
  with_a_total_of: 'with a total of',
  wolfterritories: 'Wolfterritories',
  please_note: 'Please note: The data of the current monitoring year are not yet complete! The map only shows the data until May 2025',
  info_text: 'The map of wolf distribution in the Netherlands, Belgium, Danmark, Luxembourg and Germany is a result of a cooperation of the authorities and/or implementing organisations responsible for wolf monitoring in these countries. The data are the responsibility of these countries and are collected following their national wolf monitoring plan. The data are updated once a year in November. Then, the data until 1 May of that year are added. Data from previous years can also be added.',
  nederland_bij12: 'The Netherlands: BIJ12 on behalf of the Dutch provinces',
  belgie_anb: 'Belgium: Agentschap voor Natuur en Bos (ANB) and Service public Wallonie (SPW)',
  luxemburg_anf: 'Luxembourg: Administration de la nature et des forêts (ANF)',
  duitsland_dbww: 'Germany: Dokumentations- und Beratungsstelle des Bundes zum Thema Wolf, www.dbb-wolf.de, nach den Daten der Bundesländer (Stand 15-07-2025) und Bundesamt für Naturschutz, <a target="_blank" class="hover:text-red underline" href="https://www.bfn.de/">www.bfn.de</a>',
  copyright: '© BIJ12, ANB, SPW, ANF, DBBW, November 2025',
  funded: 'This project has been funded and enabled via the EuroLargeCarnivores LIFE project (2021) and the Dutch Ministry of Agriculture, Nature and Food Quality (2022), ANB Flanders (2023), Wallonia (2024), Niedersaksen (2025)',
  download_data: 'Download data'

}

export { ENGLISH };